module.exports = __webpack_public_path__ + "img/sankaku_72_red.c8b27c5f.png";